export default "__VITE_ASSET__CvbQWLb0__"